// Link to a privacy notice served by this site. Defaults to the WhatsApp notice at /privacy/whatsapp
// (outreach-forms/public/privacy/whatsapp.html); the pre-screen pages pass /privacy/screening.
// Opens in a new tab so a half-filled form is not lost.
const PRIVACY_NOTICE_PATH = '/privacy/whatsapp';
const PRIVACY_NOTICE_LABEL = 'How we use your information';

interface PrivacyNoticeLinkProps {
  href?: string;
  label?: string;
}

function PrivacyNoticeLink({ href = PRIVACY_NOTICE_PATH, label = PRIVACY_NOTICE_LABEL }: PrivacyNoticeLinkProps) {
  return (
    <p className="privacy-link">
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    </p>
  );
}

export default PrivacyNoticeLink;
